export default __webpack_public_path__ + "static/media/points-animationgif.5ceb3893.gif";